/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import fetchHelper from "../../services/fetchHelper";
import { renderPriorityFlag } from "../InterrogationList/AllReportsUtils";

const History = () => {
  const { i } = useParams();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const getStatus = (interrogationStatus) => {
    const status = interrogationStatus;
    switch (status) {
      case "NOTASSIGNED":
        return "Not Assigned";
      case "TERMINATED":
        return "Removed";
      default:
        return status.charAt(0) + status.slice(1).toLocaleLowerCase();
    }
  };

  const fetchData = async () => {
    try {
      const urlParams = {
        where: JSON.stringify({ "patient.id": { $eq: i } }),
        match: "AND",
        matchInner: "OR",
        sort: "-interrogationDate",
      };

      const urlSearch = new URLSearchParams(urlParams);

      const data = await fetchHelper.get({
        url: "/patientmanagement/rest/interrogations/getNewInbox?" + urlSearch,
      });
      setData(data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="tabContent insurance-information">
      <div className="content">
        <div className="grpHdrPg">
          <h3>
            Patient Profile: <span>John Smith</span>
          </h3>
        </div>
        <div className="grpHdr">
          <h3>History</h3>
        </div>
        <div className="contentTbl">
          <table className="overview" id="data-table">
            <thead>
              <tr>
                <th className="hideBs" />
                <th>Alert</th>
                <th>Status</th>
                <th>Interrogation Date</th>
                <th>Visit #</th>
                <th>30 Day</th>
                <th>90 Day</th>
                <th className="showBs" />
              </tr>
            </thead>
            <tbody>
              {data.map(
                ({
                  id,
                  interrogationStatus,
                  interrogationDate,
                  visitNumber,
                  thirtyDayBillStatus,
                  nintyDayBillStatus,
                  priorityFlag,
                }) => (
                  <tr key={id} id={`inte-row-${id}`}>
                    <td className="alignCenter hideBs">
                      <button id={`inte-hide-button-${id}`} className="btn btnSm btnTealL fullWidth tableBtn">
                        View
                      </button>
                    </td>
                    <td id={`inte-priority-flag-${id}`}>
                      <div>{renderPriorityFlag({ priorityFlag })}</div>
                    </td>
                    <td id={`inte-status-${id}`}>
                      <div className="statusLbl statusLblTealL">{getStatus(interrogationStatus)}</div>
                    </td>
                    <td id={`inte-date_${id}`}>{new Date(interrogationDate).toLocaleDateString()}</td>
                    <td id={`inte-visit-number-${id}`}>{visitNumber}</td>
                    <td id={`inte-thirtyDayBillStatus-${id}`}>{thirtyDayBillStatus || "Not Enabled"}</td>
                    <td id={`inte-nintyDayBillStatus-${id}`}>{nintyDayBillStatus || "Not Enabled"}</td>
                    <td className="alignCenter showBs" id={`inte-view-td-${id}`}>
                      <a href={`/dashboard3/${id}`}>
                        <button id={`inte-view-button-${id}`} className="btn btnSm btnTealL fullWidth">
                          View
                        </button>
                      </a>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default History;
